import { createEnumHelper } from '@seiue/util'
import {
  BlockTypeEnum,
  PaperBlock,
  QuestionTypeEnum,
} from 'packages/sdks-next/growp'

/**
 * 过滤出题目block
 * @param blocks - 所有block
 * @returns 题目block
 */
export const getQuestionsFromBlock = (blocks: PaperBlock[] | null) => {
  return blocks?.filter(
    (block) => block.type === BlockTypeEnum.Question && block.questions?.length
  )
}

export const questionTypeToLabel = createEnumHelper(() => ({
  [QuestionTypeEnum.FillInBlank]: '填空',
  [QuestionTypeEnum.MultipleChoice]: '多选',
  [QuestionTypeEnum.Product]: '复合',
  [QuestionTypeEnum.ShortAnswer]: '简答',
  [QuestionTypeEnum.SingleChoice]: '单选',
  [QuestionTypeEnum.TrueOrFalse]: '判断',
}))
